import { FC } from "react";
import { message } from "antd";

import {
  clientSendOTP,
  clientVerifyLoginOTP,
} from "../../../../network/clientSide";

import LoginWithOTP from "../../../auth/loginWithOTP/LoginWithOTP";
import { setToken } from "../../../../services/store/slices/cart";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";

interface LoginProps {}

const ClientLogin: FC<LoginProps> = ({}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSuccess = (res: any) => {
    if (res?.code !== "ERR_BAD_REQUEST") {
      const roles = res?.data?.data?.user?.roles;

      if (res?.data?.data?.token) {
        if (
          roles?.length > 0 &&
          roles?.some((s: any) => s?.name === "client")
        ) {
          dispatch(setToken(res?.data?.data?.token));

          message.success(intl.formatMessage({ id: "loginSuccess" }));

          setTimeout(() => {
            navigate(-2);
          }, 1500);
          return false;
        } else {
          message.error(intl.formatMessage({ id: "uDontHavePermissions" }));
          return false;
        }
      }
    } else {
      message.error(intl.formatMessage({ id: "uDontHavePermissions" }));
      return false;
    }
  };
  return (
    <div className="shadow p-6 space-y-4 rounded-lg ">
      <div className="space-y-4">
        <h4 className="text-color-primary text-xl ">
          {intl.formatMessage({ id: "welcomeBackLogin" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "completeToLogin" })}
        </p>
      </div>
      <LoginWithOTP
        login={clientSendOTP}
        sendOTP={clientSendOTP}
        verifyOTP={clientVerifyLoginOTP}
        onLoginSuccess={onSuccess}
      />
    </div>
  );
};

export default ClientLogin;
